import React from "react";
import "../styles/pagos.css";

const currency = new Intl.NumberFormat("es-EC", { style: "currency", currency: "USD" });

const EstadoChip = ({ estado }) => {
  const map = {
    facturado: "warning",
    pagado_parcial: "info",
    pagado: "success",
    anulado: "danger",
  };
  const labels = {
    facturado: "Facturado, sin cobrar",
    pagado_parcial: "Cobro parcial",
    pagado: "Cobrado",
    anulado: "Anulado",
  };
  return <span className={`badge bg-${map[estado] || "secondary"} text-uppercase`}>{labels[estado] || estado}</span>;
};

export default function CuentasPorCobrarTable({ cuentas, loading, error, onAplicar, onCobro }) {
  return (
    <div className="management-card pagos-table h-100 d-flex flex-column">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <p className="management-eyebrow mb-1">Listado</p>
          <h6 className="mb-0">Cuentas por cobrar (facturado a crédito)</h6>
        </div>
        {loading && (
          <div className="text-muted small">
            <i className="bi bi-arrow-repeat me-2 spin" />
            Cargando...
          </div>
        )}
      </div>

      {error && <div className="alert alert-danger">Error: {error}</div>}

      <div className="table-responsive" style={{ WebkitOverflowScrolling: "touch" }}>
        <table className="table align-middle mb-0">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Empresa</th>
              <th>Factura</th>
              <th>Monto total</th>
              <th>Cupos restantes</th>
              <th>Saldo por cobrar</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {(!cuentas || cuentas.length === 0) && (
              <tr>
                <td colSpan="8" className="text-center text-muted py-4">
                  {loading ? "Cargando..." : "Sin cuentas por cobrar registradas."}
                </td>
              </tr>
            )}
            {(cuentas || []).map((c) => {
              const saldoDisponible = Number(c.saldo_disponible || 0);
              const saldoPorCobrar = Number(c.saldo_por_cobrar || 0);
              return (
                <tr key={c.id}>
                  <td>{c.fecha_emision ? new Date(c.fecha_emision).toLocaleString() : "-"}</td>
                  <td>
                    <strong>{c.deudor_nombre || `#${c.deudor_id}`}</strong>
                    {c.deudor_ruc ? <span className="text-muted ms-1 small">{c.deudor_ruc}</span> : null}
                  </td>
                  <td className="text-truncate" style={{ maxWidth: 150 }}>
                    {c.contifico_numero_factura || <span className="text-muted">-</span>}
                  </td>
                  <td><strong>{currency.format(c.monto_total || 0)}</strong></td>
                  <td>
                    {saldoDisponible > 0
                      ? <span className="text-success fw-semibold">{currency.format(saldoDisponible)}</span>
                      : <span className="text-muted">Agotado</span>}
                  </td>
                  <td>
                    {saldoPorCobrar > 0
                      ? <span className="text-warning fw-semibold">{currency.format(saldoPorCobrar)}</span>
                      : <span className="text-success">Cobrado</span>}
                  </td>
                  <td><EstadoChip estado={c.estado} /></td>
                  <td className="text-nowrap">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary me-1"
                      disabled={saldoDisponible <= 0}
                      onClick={() => onAplicar?.(c.id)}
                      title="Aplicar cupos a matrículas reales"
                    >
                      <i className="bi bi-mortarboard" /> Aplicar
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      disabled={saldoPorCobrar <= 0}
                      onClick={() => onCobro?.(c.id)}
                      title="Registrar cobro real"
                    >
                      <i className="bi bi-cash-coin" /> Cobro
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
